import React from "react";
import DSSButton from "../../../../../ui/building-blocks/atoms/dss-button";
import { ReactComponent as SuccessIcon } from "../../../../../assets/svgs/success.svg";
import "./index.scss";
import { useDssContext } from "../../../../../DSSContext";

interface Props {
    onClose: () => void;
}

const AssociationSuccessModal: React.FC<Props> = ({ onClose }) => {
    const { translate } = useDssContext();

    return (
    <div className="association-success-modal-content">
        <div className="association-success-icon">
            <SuccessIcon />
        </div>
        <div className="association-success-title">
            {translate('associationSubmittedSuccessfully')}

        </div>
        <div className="association-success-desc">
            Your Honeywell id is now successfully associated with your INDS and IDM accounts.<br />
            Going forward, you can use your Honeywell ID to login to INDS applications.
        </div>
        <div className="association-success-actions">
            <DSSButton
                id="association-success-done"
                variant="primary"
                className="exception-button"
                style={{ textTransform: 'capitalize' }}
                onClick={onClose}
            >
                {translate('done')}
            </DSSButton>
        </div>
    </div>
)};

export default AssociationSuccessModal;